import InputPrimary from "../Input";
import { useTranslation } from "react-i18next";

export default function InputPassword({
  passwordValue,
  setPasswordValue,
  errorPassword,
  setErrorPassword,
}) {
  const validatePassword = (password) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!-/:-@[-`{-~])[a-zA-Z0-9!-/:-@[-`{-~]{8,36}$/;
    return passwordRegex.test(password);
  };
  const { t } = useTranslation();
  const handleChange = (e) => {
    const inputValue = e.target.value;
    setPasswordValue(inputValue);
    if (!validatePassword(inputValue) && inputValue !== "") {
      setErrorPassword("invalid_password");
    } else {
      setErrorPassword("");
    }
  };
  return (
    <InputPrimary
      placeholder={t("password")}
      type="password"
      value={passwordValue}
      onChange={handleChange}
    />
  );
}
